document.addEventListener('DOMContentLoaded',function(){
  var color_swatch = document.querySelectorAll('.customised_template .product-customizer-swatch');
  // filetype_pc = document.querySelector('.customised_template .option-type-file input[type="file"]');
  if(color_swatch.length > 0){
    color_swatch.forEach(function(color){
      color.addEventListener('click', function(e){
        var color_value= this.dataset.value, option_label=this.closest('.product-customizer-option').querySelector('label').innerHTML.trim();
        color_swatch.forEach(function(event){ event.classList.remove('selected'); })
        this.classList.add('selected');
        this.closest('.product-customizer-select-wrap').querySelector('select[name="properties['+option_label+']"] option[value='+color_value+']').selected = true;
      })
    })
  }
  // if(filetype_pc){
  //   filetype_pc.addEventListener('change',function(){
  //     var mainObjj = this;
  //     setTimeout(function(){
  //       var filePathUploaded = mainObjj.closest('.option-type-file').querySelector('.public_url').value;
  //       if(!mainObjj.querySelector('.uploadedFile')){
  //         mainObjj.closest('.option-type-file').outerHTML += '<img class="uploadedFile" src="'+filePathUploaded+'">'
  //       }else{
  //         mainObjj.closest('.option-type-file').querySelector('.uploadedFile').src=filePathUploaded;
  //       }
  //     }, 800)
  //   })
  // }
})